/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountLookup } from '../models/AccountLookup';
import type { AccountLookupDetails } from '../models/AccountLookupDetails';
import type { BasicReportQuery } from '../models/BasicReportQuery';
import type { PagedItems } from '../models/PagedItems';
import type { PaymentListingExport } from '../models/PaymentListingExport';
import type { PaymentListingReportQuery } from '../models/PaymentListingReportQuery';
import type { RecurringSignup } from '../models/RecurringSignup';
import { request as __request } from '../core/request';

export class ReportsVService {

    /**
     * @param page
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async reportsVGetPaymentListings(
        page?: number,
        requestBody?: PaymentListingReportQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/payment-listing`,
            query: {
                'page': page,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param offsetInMinutes
     * @param requestBody
     * @returns PaymentListingExport OK
     * @throws ApiError
     */
    public static async reportsVGetPaymentListingExport(
        offsetInMinutes?: number,
        requestBody?: PaymentListingReportQuery,
    ): Promise<Array<PaymentListingExport>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/payment-listing/export`,
            query: {
                'offsetInMinutes': offsetInMinutes,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AccountLookupDetails OK
     * @throws ApiError
     */
    public static async reportsVPaymentListingAccountSearch(
        requestBody?: AccountLookup,
    ): Promise<Array<AccountLookupDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/payment-listing/accounts`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param page
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async reportsVGetRecurringSignup(
        page?: number,
        requestBody?: BasicReportQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/recurring-signup`,
            query: {
                'page': page,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns RecurringSignup OK
     * @throws ApiError
     */
    public static async reportsVGetRecurringSignupExport(
        requestBody?: BasicReportQuery,
    ): Promise<Array<RecurringSignup>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/recurring-signup/export`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param offsetInMinutes
     * @param useDistricts
     * @param requestBody
     * @returns RecurringSignup OK
     * @throws ApiError
     */
    public static async reportsVGetReconciliationExport(
        offsetInMinutes?: number,
        useDistricts: boolean = true,
        requestBody?: BasicReportQuery,
    ): Promise<Array<RecurringSignup>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reports/reconciliation/export`,
            query: {
                'offsetInMinutes': offsetInMinutes,
                'useDistricts': useDistricts,
            },
            body: requestBody,
        });
        return result.body;
    }

}